module.exports = __webpack_public_path__ + "static/media/user.4405de7c.svg";